var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.47913 10.3757C5.94701 8.96017 6.84999 7.72853 8.05924 6.85652C9.2685 5.9845 10.7223 5.51665 12.2131 5.51972C13.9031 5.51972 15.4311 6.11972 16.6311 7.10172L20.1231 3.61072C17.9951 1.75572 15.2681 0.610718 12.2131 0.610718C7.48313 0.610718 3.41112 3.30872 1.45312 7.26072L5.47913 10.3757Z",
    fill: "#FF0055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2522 18.6237C15.1622 19.3267 13.7782 19.7017 12.2122 19.7017C10.7273 19.7047 9.27902 19.2406 8.07246 18.375C6.86589 17.5094 5.96216 16.2863 5.48922 14.8787L1.44922 17.9457C2.44046 19.952 3.97449 21.6401 5.87704 22.8182C7.7796 23.9964 9.97442 24.6174 12.2122 24.6107C15.1452 24.6107 17.9472 23.5677 20.0462 21.6107L16.2532 18.6237H16.2522Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0469 21.6107C22.2419 19.5627 23.6669 16.5147 23.6669 12.6107C23.6669 11.9007 23.5579 11.1377 23.3949 10.4287H12.2129V15.0657H18.6489C18.3319 16.6247 17.4789 17.8317 16.2539 18.6237L20.0469 21.6107Z",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49001 14.8787C5.24536 14.1477 5.12108 13.3817 5.12201 12.6107C5.12201 11.8287 5.24701 11.0777 5.47901 10.3757L1.45301 7.26074C0.629385 8.92343 0.204811 10.7553 0.213007 12.6107C0.213007 14.5307 0.658007 16.3407 1.45001 17.9457L5.49001 14.8787Z",
    fill: "#FFB300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.212891 0.610718)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.bae2e93fd36d0ae96f3619f2a4320712.svg";
export { ForwardRef as ReactComponent };